/**
 * Frontile Absolute Color Palette
 *
 * Absolute OKLCH colors that remain constant across light/dark themes.
 */

const black = '#000000';

const white = '#ffffff';

export { black, white };
